import script from "./Autocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./Autocomplete.vue?vue&type=script&setup=true&lang=js"

import "./Autocomplete.vue?vue&type=style&index=0&id=3ab51c6f&lang=scss"

const __exports__ = script;

export default __exports__